import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-walking-al',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['walking'],
	},
	landing: {
		ids: ['loader-walking-f', 'age-walking-f'],
		route: {
			path: '/walking-f-al',
			name: 'walking-funnel-al',
		},
	},
	funnel: {
		id: 'ob-female-activity-walking-al',
		route: {
			path: '/walking-f-al/ob/:page*',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'female-activity-walking-al',
		},
		slug: 'activity-female-walking-al',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-walking-f-al',
	},
	upsell: {
		routeNames: ['upsell-activity-f'],
	},
	upgrade: {
		routeName: null,
	},
}

export default appAreaConfig
